import React from "react";

import BasketController from "../Controllers/BasketController";

export default function BasketWidget(props) {
    return (<BasketController {...props} />);
}



// WEBPACK FOOTER //
// ./src-js/Fratello/Basket/Widgets/BasketWidget.jsx